<template>
  <div>
    <app-toolbar :crumbs="crumbs" />

    <organization-form :item="model" @cancel="onCancel" @save="onSave" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import appToolbar from '@/components/layout/app-toolbar'
import { organizations as organizationsApi } from '@/services/api'
import organizationForm from './form'

export default {
  components: {
    appToolbar,
    organizationForm
  },
  data() {
    return {
      crumbs: [
        { text: 'Organization', to: { name: 'organizations-index' } },
        { text: 'Edit', disabled: true }
      ],
      model: {}
    }
  },
  computed: {
    ...mapGetters('messages', ['errors']),
    id() {
      return this.$route.params.organizationId
    }
  },
  async mounted() {
    this.model = await organizationsApi.fetch(this.id)
  },
  methods: {
    onCancel() {
      this.$router.go(-1)
    },
    async onSave(model) {
      await organizationsApi.put(model.id, model)
      this.$router.push({
        name: 'organization-detail',
        params: { organizationId: model.id }
      })
    }
  }
}
</script>

<style></style>
